import { WiggleBone } from "wiggle/WiggleBone";
import { WiggleRigHelper } from "wiggle/WiggleRigHelper";

export class WiggleBonesManager {
    constructor(model, wiggleConfig = {}) {
        
        this.model = model;
        this.wiggleBones = [];
        this.wiggleHelper = null;
        this.wiggleConfig = wiggleConfig;
        
        // Créer les WiggleBones immédiatement
        this.setupWiggleBones();
    }

    setupWiggleBones() {
     
        if (!this.model) {      
            return;
        }
        
      
     
            //console.log('🎯 Mode wiggleBones par armature activé');
            this.processAllArmatures();
       
    }

    processAllArmatures() {
        //console.log('🦴 Parcours du modèle pour trouver les armatures...');
        //console.log(`📋 Configuration à traiter: ${this.wiggleConfig.wiggleBones.length} armatures configurées`);
        
        // Lister toutes les configurations reçues
        this.wiggleConfig.wiggleBones.forEach((config, index) => {
            //console.log(`   ${index + 1}. Armature: "${config.armatureName}" -> Roots: [${config.wiggleRoots.join(', ')}]`);
        });
        
        // D'abord, lister toutes les armatures trouvées dans le modèle
        const foundArmatures = [];
        this.model.traverse((child) => {
            if (child.type === "Object3D" && child.children.some(c => c.type === "Bone")) {
                foundArmatures.push(child.name);
            }
        });
        //console.log(`🔍 Armatures trouvées dans le modèle: [${foundArmatures.join(', ')}]`);
        
        // Vérifier quelles configurations n'ont pas d'armature correspondante
        this.wiggleConfig.wiggleBones.forEach((config) => {
            if (!foundArmatures.includes(config.armatureName)) {
                console.warn(`⚠️ ATTENTION: Configuration pour "${config.armatureName}" mais cette armature n'existe pas dans le modèle !`);
            }
        });
        
        // Ensuite, parcourir le modèle pour traiter les armatures
        this.model.traverse((child) => {
            // Vérifier si c'est une armature (Object3D avec des bones enfants)
            if (child.type === "Object3D" && child.children.some(c => c.type === "Bone")) {
                const armatureName = child.name;
                //console.log(`\n🦴 Traitement de l'armature: ${armatureName}`);
                
                // Chercher TOUTES les configurations pour cette armature (pas seulement la première)
                const armatureConfigs = this.wiggleConfig.wiggleBones.filter(config => config.armatureName === armatureName);
                
                if (armatureConfigs.length > 0) {
                    // Fusionner tous les wiggleRoots de toutes les configurations pour cette armature
                    const allWiggleRoots = armatureConfigs.flatMap(config => config.wiggleRoots);
                    
                    //console.log(`✅ ${armatureConfigs.length} configuration(s) trouvée(s) pour armature: ${armatureName}`);
                    //console.log(`🎯 WiggleRoots combinés pour ${armatureName}:`, allWiggleRoots);
                    
                    // Compter les bones avant traitement
                    const wiggleBonesCountBefore = this.wiggleBones.length;
                    
                    // Appliquer le wiggle aux enfants des wiggleRoots
                    this.applyWiggleToArmature(child, allWiggleRoots);
                    
                    // Compter les bones après traitement
                    const wiggleBonesCountAfter = this.wiggleBones.length;
                    const wiggleBonesCreatedForThisArmature = wiggleBonesCountAfter - wiggleBonesCountBefore;
                   //console.log(`📊 ${wiggleBonesCreatedForThisArmature} WiggleBones créés pour l'armature "${armatureName}"`);
                } else {
                    //console.log(`⏭️ Pas de configuration pour armature: ${armatureName}`);
                }
            }
        });
        
        //console.log(`\n📊 TOTAL FINAL: ${this.wiggleBones.length} WiggleBones créés au total`);
    }

   

    applyWiggleToArmature(armature, wiggleRoots) {
    
        const allBonesInArmature = [];
        armature.traverse((bone) => {
            if (bone.type === "Bone") {
                allBonesInArmature.push(bone.name);
            }
        });
       //console.log(`📋 Tous les bones dans l'armature "${armature.name}": [${allBonesInArmature.join(', ')}]`);
        
        // Chercher et traiter chaque wiggleRoot
        wiggleRoots.forEach((rootName) => {
            //console.log(`\n🔍 Recherche du wiggleRoot: "${rootName}"`);
            let rootFound = false;
            
            armature.traverse((bone) => {
                if (bone.type === "Bone" && bone.name === rootName) {
                    //console.log(`✅ WiggleRoot trouvé: ${bone.name}`);
                    rootFound = true;
                    
                    const wiggleBonesCountBefore = this.wiggleBones.length;
                    this.applyWiggleToChildren(bone);
                    const wiggleBonesCountAfter = this.wiggleBones.length;
                    const wiggleBonesCreatedForThisRoot = wiggleBonesCountAfter - wiggleBonesCountBefore;
                    //console.log(`📊 ${wiggleBonesCreatedForThisRoot} WiggleBones créés pour la racine "${rootName}"`);
                }
            });
            
            if (!rootFound) {
                console.warn(`❌ WiggleRoot "${rootName}" non trouvé dans l'armature "${armature.name}"`);
            }
        });
    }

 

    applyWiggleToChildren(parentBone, depth = 0) {
        const indent = '  '.repeat(depth);
        
        // IMPORTANT: Copier la liste des enfants AVANT de créer les WiggleBones
        // car WiggleBone modifie la hiérarchie des bones
        const childrenSnapshot = parentBone.children.filter(child => child.type === "Bone");
        
       //console.log(`${indent}🔍 Traitement des enfants de "${parentBone.name}" (${childrenSnapshot.length} bones)`);
        
        // D'abord, collecter récursivement TOUS les bones à traiter
        const allBonesToProcess = [];
        const collectBones = (bone) => {
            const boneChildren = bone.children.filter(c => c.type === "Bone");
            boneChildren.forEach(child => {
                allBonesToProcess.push(child);
                collectBones(child);
            });
        };
        collectBones(parentBone);
        
       //console.log(`${indent}📋 Bones à traiter: [${allBonesToProcess.map(b => b.name).join(', ')}]`);
        
        // Ensuite, créer les WiggleBones pour tous les bones collectés
        allBonesToProcess.forEach((bone, index) => {
           //console.log(`${indent}  └─ Bone ${index}: "${bone.name}"`);
            try {
                const wiggleBone = new WiggleBone(bone, {
                    velocity: 0.5,
                    maxAngle: 0.1,
                    dampening: 0.9
                });
                this.wiggleBones.push(wiggleBone);
               //console.log(`${indent}     ✅ WiggleBone créé pour "${bone.name}"`);
            } catch (error) {
                console.error(`❌ Erreur lors de la création du WiggleBone pour ${bone.name}:`, error);
            }
        });
    }

    update(deltaTime = 0.016) {
        if (this.wiggleBones.length > 0) {
            this.wiggleBones.forEach((wiggleBone, index) => {
                try {
                    wiggleBone.update(deltaTime);
                } catch (error) {
                    console.error(`❌ Erreur lors de l'update du WiggleBone ${index}:`, error);
                }
            });
        }
    }
}
